import { lazy } from 'react';
import { Route } from 'react-router';

const InterstitialPage = lazy(() => import('@/pages/Interstitial.tsx'));

export const InterstitialRoutes = () => (
  <>
    {/* Main interstitial route */}
    <Route path="/interstitial" element={<InterstitialPage />} />

    {/* Specific interstitial type routes for testing and direct access */}
    <Route path="/interstitial/statistics" element={<InterstitialPage />} />
    <Route path="/interstitial/statistics-alt" element={<InterstitialPage />} />

    <Route path="/interstitial/linear-progress" element={<InterstitialPage />} />
    <Route path="/interstitial/circular-progress" element={<InterstitialPage />} />
    <Route
      path="/interstitial/circular-progress-with-welcome-steps"
      element={<InterstitialPage />}
    />
    <Route path="/interstitial/results-loader" element={<InterstitialPage />} />
    <Route path="/interstitial/progress" element={<InterstitialPage />} />
    <Route path="/interstitial/multi-testimonial" element={<InterstitialPage />} />
    <Route path="/interstitial/performance-chart" element={<InterstitialPage />} />
    <Route path="/interstitial/product-info" element={<InterstitialPage />} />
    <Route path="/interstitial/product-formulation" element={<InterstitialPage />} />
    <Route path="/interstitial/doctor" element={<InterstitialPage />} />
    <Route path="/interstitial/state-availability" element={<InterstitialPage />} />
    <Route path="/interstitial/sleep-stats" element={<InterstitialPage />} />
    <Route path="/interstitial/welcome-steps" element={<InterstitialPage />} />
  </>
);
